var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-5.511 0-10 4.489-10 10s4.489 10 10 10 10-4.489 10-10-4.489-10-10-10zm0 2c4.4301 0 8 3.56988 8 8 0 4.4301-3.5699 8-8 8-4.43012 0-8-3.5699-8-8 0-4.43012 3.56988-8 8-8zm4.293 4.29297-6.293 6.29293-2.29297-2.2929-1.41406 1.414 3.70703 3.7071 7.707-7.70707z",
    fill: "#000"
  })));
}
export default SvgOkreact;